module.exports = __webpack_public_path__ + "img/language_profe_help.0d83c7e4.svg";